import script from "./TestimonySection.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonySection.vue?vue&type=script&setup=true&lang=js"

import "./TestimonySection.vue?vue&type=style&index=0&id=d20c91a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d20c91a4"]])

export default __exports__